import type { DocMigration } from "../docMigration";

const docEntityTableFieldsToEntityType = {
  underlays: "UNDERLAY",
  blocks: "BLOCK",
  rooms: "ROOM",
  stairSystems: "STAIR_SYSTEM",
  stairBlocks: "STAIR_BLOCK",
  railings: "RAILING",
  roofSystems: "ROOF_SYSTEM",
  roofs: "ROOF",
  foundationSystems: "FOUNDATION_SYSTEM",
  foundations: "FOUNDATION",
  elevations: "ELEVATION",
  facades: "FACADE",
  referenceGeom: "REFERENCE_GEOM",
  sheets: "SHEET",
  drawingRefs: "DRAWING_REF",
  palettes: "PALETTE",
  annotation: "ANNOTATION",
  casework: "CASEWORK",
  ceilings: "CEILING",
  props: "PROP",
  levels: "LEVEL",
  gableOpenings: "GABLE_OPENING",
  groups: "GROUP",
  settingsSets: "SETTINGS_SET",
  settings: "SETTINGS",
  dormers: "DORMER",
  skylights: "SKYLIGHT",
  modifiers: "MODIFIER",
  edgeModifiers: "EDGE_MODIFIER",
  openings: "OPENING",
  floors: "FLOOR",
  optionSets: "OPTION_SET",
  auxOptionSets: "AUX_OPTION_SET",
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_131: DocMigration = {
  maxSchemaVersion: "0.0.131",
  description: "Ensure that DocEntityBase entities have their entityType set",
  apply(json: any) {
    for (const docField in docEntityTableFieldsToEntityType) {
      const updatedTable = {};
      const table = json[docField];

      if (!table) {
        continue;
      }

      const entityType = docEntityTableFieldsToEntityType[docField];

      for (const id in table) {
        const entity = table[id];

        if (entity.entityType === entityType) {
          updatedTable[id] = entity;
        } else {
          updatedTable[id] = {
            ...entity,
            entityType,
          };
        }
      }
      json = {
        ...json,
        [docField]: updatedTable,
      };
    }

    return json;
  },
};

export default migration_0_0_131;
